import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import _extends from '@babel/runtime/helpers/esm/extends';
import React, { useMemo, useRef, useEffect } from 'react';
import { mergeRefs } from '@elliemae/ds-utilities/system';
import { ScrollSync, ScrollSyncPane } from '@elliemae/ds-shared/ScrollSync';
import createInstancePlugin from '@elliemae/ds-shared/createDataInstance/createInstancePlugin';
import { getScrollbarWidth } from '../../utilities/getScrollbarSize.js';

getScrollbarWidth(2);

var HeaderSyncHoc = function HeaderSyncHoc(Component) {
  return function (props) {
    return /*#__PURE__*/React.createElement(ScrollSyncPane, null, function (_ref) {
      var registerPane = _ref.registerPane;
      return /*#__PURE__*/React.createElement(Component, _extends({}, props, {
        innerRef: mergeRefs(props.innerRef, registerPane)
      }));
    });
  };
};

var BodySyncHoc = function BodySyncHoc(Component, notPaginated, grid) {
  return function (_ref2) {
    _ref2.children;
        var classProps = _ref2.classProps,
        columns = _ref2.columns,
        getContainer = _ref2.getContainer,
        helperClass = _ref2.helperClass,
        innerBodyRef = _ref2.innerBodyRef,
        innerRef = _ref2.innerRef,
        isPlaceholderActive = _ref2.isPlaceholderActive,
        listProps = _ref2.listProps,
        lockAxis = _ref2.lockAxis,
        noResultsPlaceholder = _ref2.noResultsPlaceholder,
        numRowsVisible = _ref2.numRowsVisible,
        onSortEnd = _ref2.onSortEnd,
        onSortOver = _ref2.onSortOver,
        onSortStart = _ref2.onSortStart,
        rowKey = _ref2.rowKey,
        rowRenderer = _ref2.rowRenderer,
        rows = _ref2.rows,
        useDragHandle = _ref2.useDragHandle,
        className = _ref2.className,
        listComponent = _ref2.listComponent,
        rest = _objectWithoutProperties(_ref2, ["children", "classProps", "columns", "getContainer", "helperClass", "innerBodyRef", "innerRef", "isPlaceholderActive", "listProps", "lockAxis", "noResultsPlaceholder", "numRowsVisible", "onSortEnd", "onSortOver", "onSortStart", "rowKey", "rowRenderer", "rows", "useDragHandle", "className", "listComponent"]);

    var t = useRef();

    var repositionToolbarBasedOnBodyScrollPosition = function repositionToolbarBasedOnBodyScrollPosition(SCROLLBAR_WIDTH) {
      return function () {
        grid.refs.body.current.style.setProperty('--toolbar-scroll', "".concat(grid.refs.body.current.offsetWidth + grid.refs.body.current.scrollLeft - 15, "px"));
        grid.refs.body.current.style.setProperty('--toolbar-scroll-paginated', "".concat(grid.refs.body.current.offsetWidth + grid.refs.body.current.scrollLeft - 19, "px"));
      };
    };

    useEffect(function () {
      setTimeout(repositionToolbarBasedOnBodyScrollPosition(), 300);
    }, []);
    useEffect(function () {
      window.addEventListener('resize', repositionToolbarBasedOnBodyScrollPosition());
      return function () {
        window.removeEventListener('resize', repositionToolbarBasedOnBodyScrollPosition());
      };
    });
    return /*#__PURE__*/React.createElement(ScrollSyncPane, {
      notPaginated: notPaginated
    }, function (_ref3) {
      var registerPane = _ref3.registerPane;
      return /*#__PURE__*/React.createElement(Component, _extends({
        ref: t,
        classProps: classProps,
        className: className,
        listComponent: listComponent,
        columns: columns,
        getContainer: getContainer,
        helperClass: helperClass,
        innerBodyRef: innerBodyRef // innerRef={innerRef}
        ,
        isPlaceholderActive: isPlaceholderActive,
        listProps: listProps,
        lockAxis: lockAxis,
        noResultsPlaceholder: noResultsPlaceholder,
        numRowsVisible: numRowsVisible,
        onSortEnd: onSortEnd,
        onSortOver: onSortOver,
        onSortStart: onSortStart,
        rowKey: rowKey,
        rowRenderer: rowRenderer,
        rows: rows,
        useDragHandle: useDragHandle,
        innerRef: mergeRefs(innerRef, registerPane, t)
      }, rest));
    });
  };
};

var TableSyncHoc = function TableSyncHoc(Component) {
  return function (props) {
    return /*#__PURE__*/React.createElement(ScrollSync, {
      proportional: false,
      onScroll: function onScroll(e) {
        e.target.style.setProperty('--toolbar-scroll', "".concat(e.target.offsetWidth + e.target.scrollLeft - 15, "px"));
        e.target.style.setProperty('--toolbar-scroll-paginated', "".concat(e.target.offsetWidth + e.target.scrollLeft - 19, "px"));
      }
    }, /*#__PURE__*/React.createElement(Component, props));
  };
};

var decorateRenderers = function decorateRenderers(renderers, grid) {
  var HeaderWrapper = renderers.header.wrapper;
  var BodyWrapper = renderers.body.wrapper;
  var Table = renderers.table;
  var paginated = grid.props.paginated;
  renderers.table = useMemo(function () {
    return TableSyncHoc(Table);
  }, []);
  renderers.header.wrapper = useMemo(function () {
    return HeaderSyncHoc(HeaderWrapper);
  }, []);
  renderers.body.wrapper = useMemo(function () {
    return BodySyncHoc(BodyWrapper, !paginated, grid);
  }, []);
  return renderers;
};

var BodyHeaderScrollSyncPlugin = createInstancePlugin('body-header-scroll-sync', {
  decorateRenderers: decorateRenderers
});

export { BodyHeaderScrollSyncPlugin };
//# sourceMappingURL=BodyHeaderScrollSyncPlugin.js.map
